import React, {createContext, useContext, useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const ExplainBox = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 15px;
  border: 1px solid ${props => {
    let border = props.theme.color.default_border_color;
    if (props.open) border = props.theme.color.green_100;
    return border;
  }};
  background-color: ${props => {
    let color = props.theme.color.site_main_color;
    if (props.open) color = props.theme.color.green_200
    return color;
  }};
  padding: 6px 9px 6px 10px;
  cursor: pointer;

  &:hover {
    background: ${props => {
      let color = props.theme.color.white_200;
      if (props.open) color = props.theme.color.green_200;
      return color;
    }};
  }
`;

const ExplainText = styled.span`
  flex: 1;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  color: ${props => props.theme.color.dark_100};
  margin-right: 7px;
`;

const HeaderExplainText = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${props => {
    let color = props.theme.color.dark_200
    if (props.open) color = props.theme.color.green_100;
    return color
  }};

  &:hover {
    color: ${props => props.theme.color.green_100};
  }
`;

const DropDownContext = createContext();


const Dropdown = ({children}) => {
    const [open, toggle] = useState(false);

    const ref = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref?.current?.contains(event.target)) {
                toggle(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);


    const providerValue = {open, toggle};
    return (
        <DropDownContext.Provider value={providerValue}>
            <div ref={ref}>
                {children}
            </div>
        </DropDownContext.Provider>
    );
};


const Button = ({children}) => {
    const {toggle} = useContext(DropDownContext);


    const onClick = () => {
        toggle(prev => !prev)
    }

    return (
        <div onClick={onClick}>
            {children}
        </div>
    );
};


const List = ({children}) => {
    const {open} = useContext(DropDownContext);

    return open ? <div>{children}</div> : null
}

const Item = ({children}) => {
    const {toggle} = useContext(DropDownContext);

    const onClick = () => {
        toggle(false)
    }

    return <div onClick={onClick} className={'dropdown-item'}>{children}</div>
}

const ExplainButton = ({title}) => {
    const {t} = useTranslation();
    const {open} = useContext(DropDownContext);
    return (
        <ExplainBox open={open}>
            <ExplainText>
                {title}
            </ExplainText>
            <img src={`./images/icon_arrow_down_${open ? 'open' : 'close'}.svg`} width={18} height={18}/>
        </ExplainBox>
    )
}
const HeaderExplainButton = () => {
    const {t} = useTranslation();
    const {open} = useContext(DropDownContext);
    return (
            <HeaderExplainText open={open}>
                {t('explain.homeButton')}
            </HeaderExplainText>
    )
}

Dropdown.Button = Button;
Dropdown.List = List;
Dropdown.Item = Item;
Dropdown.ExplainButton = ExplainButton
Dropdown.HeaderExplainButton = HeaderExplainButton


export default Dropdown;
